module.exports = __webpack_public_path__ + "img/ancient-astronauts.066cb5dc.jpg";